import React, { useContext, useState } from 'react';
import { Map } from 'leaflet';

type ContextType = {
  lat: number;
  setLat: (lat: number) => void;
  long: number;
  setLong: (long: number) => void;
  map: Map | null;
  setMap: (map: Map | null) => void;
  marker: L.Marker<number> | null;
  setMarker: (marker: L.Marker<number> | null) => void;
  terrain: string;
  setTerrain: (terrain: string) => void;
  summary: string;
  setSummary: (summary: string) => void;
  coords: any;
  setCoords: (coords: any) => void;
};
type Props = {
  children: React.ReactNode;
};

export const MapContextProvider = ({ children }: Props): JSX.Element => {
  const [lat, setLat] = useState<number>(59.891008);
  const [long, setLong] = useState<number>(10.6193012);
  const [map, setMap] = useState<Map | null>(null);
  const [marker, setMarker] = useState<L.Marker<number> | null>(null);
  const [terrain, setTerrain] = useState('');
  const [summary, setSummary] = useState('');
  const [coords, setCoords] = useState({});

  const value = {
    lat,
    setLat,
    long,
    setLong,
    map,
    setMap,
    marker,
    setMarker,
    terrain,
    setTerrain,
    summary,
    setSummary,
    coords,
    setCoords,
  };

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};

export const MapContext = React.createContext({} as ContextType);
export const useMapContext = (): ContextType => useContext(MapContext);
